
import { Component, Prop, Vue } from "vue-property-decorator";
import AppButton from "@/modules/shared/components/AppButton.vue";
import AppLoadIcon from "@/modules/shared/components/AppLoadIcon.vue";

@Component({
  components: {
    AppButton,
    AppLoadIcon,
  },
})
export default class IdentityProvidersButtonInformationCard extends Vue {
  @Prop()
  public readonly iconId!: number;

  @Prop()
  public readonly buttonText!: string;
}
